import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { upload_receipt } from "../../actions/users";

export default function FileUploader(props) {
  const dispatch = useDispatch();
  const [showUpload, setShowUpload] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const toggleVisibility = () => {
    setShowUpload(!showUpload);
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]); // For single file upload
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      console.log("No hay file...");
      return;
    }
    console.log("Uploading file...");

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("invoice_number", props.invoice_number);

    dispatch(upload_receipt(formData));
  };

  return (
    <>
      <label htmlFor="filePicker" onClick={toggleVisibility} className="btn">
        Agregar recibo
      </label>
      <div>
        <input
          id="filePicker"
          style={{ visibility: "hidden" }}
          type={"file"}
          onChange={handleFileChange}
        ></input>
      </div>

      {selectedFile && (
        <>
          <p>Archivo seleccionado: {selectedFile.name}</p>
          <button className="btn" onClick={handleUpload}>
            Subir archivo
          </button>
        </>
      )}
    </>
  );
}
